<script setup lang="ts">
import { onMounted } from "vue";
import {
  AppLoading,
  EcxBusy,
  EcxConfirmationDialog,
  EcxToast,
} from "@edgeconnex/design-system";

import { bootstrapReady } from "./bootstrapState";

function initializeTheme() {
  const storedTheme = window.localStorage.getItem("theme");
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  // Explicit light/dark wins; 'system' and absent both follow the OS scheme.
  document.documentElement.classList.toggle(
    "my-app-dark",
    storedTheme === "dark" || storedTheme === "light" ? storedTheme === "dark" : prefersDark,
  );
}

onMounted(() => {
  initializeTheme();
});
</script>

<template>
  <AppLoading v-if="!bootstrapReady" />
  <template v-else>
    <router-view />
  </template>
  <EcxConfirmationDialog group="ecx-confirm" />
  <EcxToast :limit="8" />
  <EcxBusy />
</template>
